import { render } from "./trustedListStatus.vue?vue&type=template&id=ed06767c"
import script from "./trustedListStatus.vue?vue&type=script&lang=js"
export * from "./trustedListStatus.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__